<template>
    <Form
        ref="Form"
        :form="form"
        :model="model"
    />

</template>

<script>
//Components
import Form from '../components/medicamento-nao-atendido/Form'

export default {
    components: { Form },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    }
}
</script>